import React, { useState } from 'react';
import { ChevronDownIcon, MenuIcon, MountainIcon, XIcon } from 'lucide-react';
import { Link, NavLink, useLocation } from 'react-router-dom';
type MenuItem = {
  label: string;
  to: string;
};
const aboutItems: MenuItem[] = [{
  label: 'Who We Are',
  to: '/about/who-we-are'
}, {
  label: 'Why Choose Us',
  to: '/about/why-choose-us'
}, {
  label: 'Explore Our Team',
  to: '/about/team'
}, {
  label: 'Terms and Conditions',
  to: '/about/terms'
}, {
  label: 'Blogs',
  to: '/about/blogs'
}, {
  label: 'Legal Documents',
  to: '/about/legal-documents'
}];
const routeItems: MenuItem[] = [{
  label: 'Manaslu Circuit Trek',
  to: '/routes/manaslu-circuit'
}];
const desktopLinkClass = ({
  isActive
}: {
  isActive: boolean;
}) => `border-b pb-1 text-xs font-semibold uppercase tracking-[0.15em] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#9a7b3e] focus-visible:ring-offset-4 ${isActive ? 'border-[#a98b50] text-[#233a32]' : 'border-transparent text-[#53645b] hover:border-[#a98b50] hover:text-[#233a32]'}`;
export function Header() {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);
  const [routesOpen, setRoutesOpen] = useState(false);
  const [mobileAboutOpen, setMobileAboutOpen] = useState(false);
  const [mobileRoutesOpen, setMobileRoutesOpen] = useState(false);
  const isAboutActive = location.pathname === '/about' || location.pathname.startsWith('/about/');
  const isRouteActive = location.pathname === '/' || location.pathname.startsWith('/routes/');
  const closeMobile = () => setMobileOpen(false);
  return <header className="sticky top-0 z-50 border-b border-[#d9d0bf] bg-[#f7f4ed]/95 text-[#233a32] backdrop-blur-sm" data-id="element-109" data-mp="30lwpxmzvshe2">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-5 sm:px-8" data-id="element-110" data-mp="1xqxr06t86u9">
        <Link to="/" aria-label="Manaslu Trekking home" className="inline-flex items-center gap-2.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#9a7b3e] focus-visible:ring-offset-4" data-id="element-111" data-mp="3t9sl2n9sy18q">
          <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center border border-[#9a7b3e]/70 text-[#9a7b3e]" data-id="element-112" data-mp="1ho1gkz8bp1yu">
            <MountainIcon className="h-5 w-5" aria-hidden="true" data-id="element-113" data-mp="1mltb810cr26q" />
          </span>
          <span className="font-serif text-xl tracking-[0.03em] text-[#233a32] sm:text-2xl" data-id="element-114" data-mp="18mtwpm6k03oa">
            Manaslu Trekking
          </span>
        </Link>

        <nav className="hidden items-center gap-6 lg:flex" aria-label="Primary navigation" data-id="element-115" data-mp="1cmkjlesylznj">
          <div className="relative" data-id="element-116" data-mp="13nz0nijksim8">
            <button type="button" onClick={() => setRoutesOpen(open => !open)} aria-expanded={routesOpen} className={`inline-flex items-center gap-1 border-b pb-1 text-xs font-semibold uppercase tracking-[0.15em] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#9a7b3e] focus-visible:ring-offset-4 ${isRouteActive ? 'border-[#a98b50] text-[#233a32]' : 'border-transparent text-[#53645b] hover:border-[#a98b50] hover:text-[#233a32]'}`} data-id="element-117" data-mp="13p1x05zo3d9j">
              Routes{' '}
              <ChevronDownIcon className={`h-3.5 w-3.5 transition-transform ${routesOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-118" data-mp="w6ar9ug5kv2f" />
            </button>
            {routesOpen && <Dropdown items={routeItems} onNavigate={() => setRoutesOpen(false)} data-id="element-119" data-mp="106kux0gh39e4" />}
          </div>
          <NavLink to="/guides" className={desktopLinkClass} data-id="element-120" data-mp="1f1968v8k121n">
            Guide
          </NavLink>
          <div className="relative" data-id="element-121" data-mp="1a26017gu8ps3">
            <button type="button" onClick={() => setAboutOpen(open => !open)} aria-expanded={aboutOpen} className={`inline-flex items-center gap-1 border-b pb-1 text-xs font-semibold uppercase tracking-[0.15em] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#9a7b3e] focus-visible:ring-offset-4 ${isAboutActive ? 'border-[#a98b50] text-[#233a32]' : 'border-transparent text-[#53645b] hover:border-[#a98b50] hover:text-[#233a32]'}`} data-id="element-122" data-mp="3gu6v6fz7nahb">
              About Us{' '}
              <ChevronDownIcon className={`h-3.5 w-3.5 transition-transform ${aboutOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-123" data-mp="2gxnbyz8o7kd3" />
            </button>
            {aboutOpen && <Dropdown items={aboutItems} onNavigate={() => setAboutOpen(false)} data-id="element-124" data-mp="1t8vpmohrhw88" />}
          </div>
          <NavLink to="/contact" className={desktopLinkClass} data-id="element-125" data-mp="1y15bntfrac58">
            Contact
          </NavLink>
        </nav>

        <Link to="/plan-your-trek" className="hidden border border-[#9a7b3e] bg-[#233a32] px-4 py-3 text-xs font-semibold uppercase tracking-[0.15em] text-[#f7f4ed] transition-colors hover:bg-[#9a7b3e] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#9a7b3e] focus-visible:ring-offset-4 lg:inline-flex" data-id="element-126" data-mp="11hfwscpm3d9k">
          Inquiry
        </Link>
        <button type="button" className="rounded-sm p-2 text-[#233a32] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#9a7b3e] lg:hidden" onClick={() => setMobileOpen(open => !open)} aria-label={mobileOpen ? 'Close menu' : 'Open menu'} aria-expanded={mobileOpen} data-id="element-127" data-mp="oxrbzxgdwh56">
          {mobileOpen ? <XIcon className="h-6 w-6" aria-hidden="true" data-id="element-128" data-mp="5al8doooy1if" /> : <MenuIcon className="h-6 w-6" aria-hidden="true" data-id="element-129" data-mp="19htb4egw9i9" />}
        </button>
      </div>

      {mobileOpen && <nav className="border-t border-[#d9d0bf] bg-[#f7f4ed] px-5 py-5 lg:hidden" aria-label="Mobile navigation" data-id="element-130" data-mp="3sg2ei7hucn7d">
          <div className="mx-auto max-w-7xl space-y-1" data-id="element-131" data-mp="3nhhm2u8tz7th">
            <MobileGroup label="Routes" open={mobileRoutesOpen} onToggle={() => setMobileRoutesOpen(open => !open)} items={routeItems} onNavigate={closeMobile} data-id="element-132" data-mp="3dsu7livkf417" />
            <MobileLink to="/guides" onNavigate={closeMobile} data-id="element-133" data-mp="33x0pljz2uic1">
              Guide
            </MobileLink>
            <MobileGroup label="About Us" open={mobileAboutOpen} onToggle={() => setMobileAboutOpen(open => !open)} items={aboutItems} onNavigate={closeMobile} data-id="element-134" data-mp="38vu2pbagc7bo" />
            <MobileLink to="/contact" onNavigate={closeMobile} data-id="element-135" data-mp="3mujx2j5vzswc">
              Contact
            </MobileLink>
            <Link to="/plan-your-trek" onClick={closeMobile} className="mt-4 block bg-[#233a32] px-4 py-3 text-center text-xs font-semibold uppercase tracking-[0.15em] text-[#f7f4ed]" data-id="element-136" data-mp="3rrk7f69rrht9">
              Send an inquiry
            </Link>
          </div>
        </nav>}
    </header>;
}
function Dropdown({
  items,
  onNavigate
}: {
  items: MenuItem[];
  onNavigate: () => void;
}) {
  return <div className="absolute left-0 top-full mt-4 w-64 border border-[#d9d0bf] bg-[#f7f4ed] p-2 shadow-xl" data-id="element-137" data-mp="2ik0ev5mzu62c">
      {items.map(item => <Link key={item.to} to={item.to} onClick={onNavigate} className="block px-4 py-3 text-sm text-[#3c5148] transition-colors hover:bg-[#efe9dc] hover:text-[#233a32] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#9a7b3e]" data-id="element-138" data-mp="2dlymtv7laweq">
          {item.label}
        </Link>)}
    </div>;
}
function MobileGroup({
  label,
  open,
  onToggle,
  items,
  onNavigate
}: {
  label: string;
  open: boolean;
  onToggle: () => void;
  items: MenuItem[];
  onNavigate: () => void;
}) {
  return <div data-id="element-139" data-mp="3ad0u2jrb11ns">
      <button type="button" onClick={onToggle} aria-expanded={open} className="flex w-full items-center justify-between py-3 text-left text-sm font-semibold uppercase tracking-[0.14em] text-[#233a32] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#9a7b3e]" data-id="element-140" data-mp="369kylqqz17co">
        {label}
        <ChevronDownIcon className={`h-4 w-4 transition-transform ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-141" data-mp="1dktr268zdwj3" />
      </button>
      {open && <div className="mb-2 border-l border-[#d9d0bf] pl-4" data-id="element-142" data-mp="1mdnlxc0wv4i2">
          {items.map(item => <Link key={item.to} to={item.to} onClick={onNavigate} className="block py-2 text-sm text-[#53645b] hover:text-[#9a7b3e] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#9a7b3e]" data-id="element-143" data-mp="1rc8b8gemk3rq">
              {item.label}
            </Link>)}
        </div>}
    </div>;
}
function MobileLink({
  to,
  onNavigate,
  children
}: {
  to: string;
  onNavigate: () => void;
  children: string;
}) {
  return <Link to={to} onClick={onNavigate} className="block py-3 text-sm font-semibold uppercase tracking-[0.14em] text-[#233a32] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#9a7b3e]" data-id="element-144" data-mp="2k6wrhk4f5x81">
      {children}
    </Link>;
}